<template>
    <div class="BaseRange">
        <label class="BaseRange-label" v-if="label">{{ label }}:</label>
        <div class="BaseRange-inputHolder">
            <input
                    type="range"
                    v-bind="$attrs"
                    :value="modelValue"
                    @input="$emit('update:modelValue', $event.target.value)"
            >
            <div class="BaseRange-value">
                <template v-if="map">
                    {{ map[modelValue] }}
                </template>
                <template v-else>
                    <span v-if="prefix">{{prefix}}</span> {{modelValue}}
                </template>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
	    name: 'BaseRange',
		props: {
			label: String,
			modelValue: [String, Number],
            prefix: String,
            map: Object
		}
	}
</script>

<style lang="scss" scoped>
    @mixin thumb() {
        border: none;
        width: 1.25rem; height: 1.25rem;
        border-radius: 0;
        background: var(--colorBrand);
        pointer-events: auto;
        z-index: 1;
        position: relative;
        margin-top: -.4rem;
        cursor: pointer;
    }

    @mixin track() {
        width: 100%; height: .5rem;
        background: var(--colorBrandLighten);
        z-index: 2;
        position: relative;
    }

    .BaseRange {
        &-label {
            display: block;
            font-weight: 700;
            margin-bottom: .5em;

            &.is-inline {
                display: inline;
                margin-right: .5em;
            }
        }

        &-inputHolder {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }

        &-value {
            min-width: 5rem;
            text-align: right;
            font-weight: 700;
            margin-left: 1rem;
        }

        input {
            z-index: 1;
            top: 0; left: 0;
            margin: 0;
            background: none;
            color: #000;
            pointer-events: none;
            width: 100%;
            outline: none;
            flex: 1;
            max-width: 40rem;

            &::-webkit-slider-runnable-track { @include track }
            &::-moz-range-track { @include track }

            &::-webkit-slider-thumb { @include thumb }
            &::-moz-range-thumb { @include thumb }

            &::-webkit-slider-runnable-track,
            &::-webkit-slider-thumb, & {
                -webkit-appearance: none
            }

            &:focus {
                z-index: 2;
                outline: none;
                color: var(--colorBrand);
            }
        }
    }
</style>
